import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

const supabaseWeatherUrl = process.env.REACT_APP_SUPABASE_PROD_URL
const supabaseWeatherAnonKey = process.env.REACT_APP_SUPABASE_PROD_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true }
})

export const supabaseWeather = createClient(supabaseWeatherUrl, supabaseWeatherAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true }
})
